import { render, staticRenderFns } from "./CategoryContentArticles.vue?vue&type=template&id=20485954&scoped=true"
import script from "./CategoryContentArticles.vue?vue&type=script&lang=js"
export * from "./CategoryContentArticles.vue?vue&type=script&lang=js"
import style0 from "./CategoryContentArticles.vue?vue&type=style&index=0&id=20485954&prod&lang=scss&scoped=true"
import style1 from "./CategoryContentArticles.vue?vue&type=style&index=1&id=20485954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20485954",
  null
  
)

export default component.exports